export enum BaseCriterionNameEnum {
    contractorCarriers = "contractorCarriers",
    contractorSenders = "contractorSenders",
    contractorPayers = "contractorPayers",
    disponents = "disponents",
    contractorSendersAccountManagers = "contractorSendersAccountManagers",
    dateFrom = "dateFrom",
    dateTo = "dateTo",
    dateType = "dateType",
    departmentList = "departmentList",
    includeContractorCarriers = "includeContractorCarriers",
    includeContractorSenders = "includeContractorSenders",
    includeContractorPayers = "includeContractorPayers",
    includeDisponents = "includeDisponents",
}
